"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DepartmentSelectorModal = exports.DepartmentSelector = void 0;
const tslib_1 = require("tslib");
const mobx_1 = require("mobx");
const icons_1 = require("../../components/icon/icons");
const index_1 = require("../../components/icon/index");
const radio_input_1 = require("../../components/input/radio.input");
const radio_input_state_1 = require("../../components/input/radio.input.state");
const mithril_component_1 = require("../../components/mithril.component");
const modal_form_component_1 = require("../../components/modal.form/modal.form.component");
const theme_1 = require("../../components/theme");
const index_2 = require("../../i18n/index");
const mithril_1 = require("../../mithril");
const page_1 = require("../../page/page");
const index_3 = require("../../services/index");
const department_selector_style_1 = require("./department.selector.style");
(0, theme_1.addStyles)(department_selector_style_1.Style);
class DepartmentSelector extends mithril_component_1.IMithrilComponent {
    constructor() {
        super();
        this.modal = new DepartmentSelectorModal({
            title: index_2.T.DEPARTMENT_SELECTOR_TITLE,
            confirm: index_2.T.DEPARTMENT_SELECTOR_ACCEPT,
            success: { key: index_2.T.DEPARTMENT_SELECTOR_SUCCESS }
        });
    }
    get nodes() {
        if (index_3.Services.Department.current == null) {
            return null;
        }
        const oneDepartment = index_3.Services.Department.departments.length < 2;
        const isDepartmentDisabled = this.modal.isDepartmentDisabled(index_3.Services.Department.current);
        const departmentName = isDepartmentDisabled ? `${index_3.Services.Department.current.displayName} (${(0, index_2.Translate)(index_2.T.DEPARTMENT_SELECTOR_DISABLED)})` : index_3.Services.Department.current.displayName;
        const departmentClass = isDepartmentDisabled ? `${department_selector_style_1.CSS.department} ${department_selector_style_1.CSS.departmentDisabled}` : department_selector_style_1.CSS.department;
        return (0, mithril_1.m)('div', { className: department_selector_style_1.CSS.container }, [
            (0, mithril_1.m)('button', { className: `mdl-button ${department_selector_style_1.CSS.btn}`, disabled: oneDepartment, onclick: () => this.openModal() }, [
                index_1.Icon.view(icons_1.MaterialIcon.DEPARTMENT, { className: department_selector_style_1.CSS.icon }),
                (0, mithril_1.m)('span', { className: departmentClass }, departmentName)
            ])
        ]);
    }
    openModal() {
        this.modal.open();
    }
}
exports.DepartmentSelector = DepartmentSelector;
class DepartmentSelectorModal extends modal_form_component_1.ModalFormComponent {
    constructor() {
        super(...arguments);
        this.states = mobx_1.observable.array([], { deep: false });
    }
    open() {
        super.open();
        this.states.replace(this.getStates());
    }
    getStates() {
        const states = [];
        const radioGroup = 'department-select';
        const currentDepartmentId = index_3.Services.Department.current.objectId;
        for (const department of index_3.Services.Department.departments) {
            const isCurrentDepartment = department.objectId === currentDepartmentId;
            const isDepartmentDisabled = this.isDepartmentDisabled(department);
            const departmentNameCurrent = isCurrentDepartment ? `${department.displayName} (${(0, index_2.Translate)(index_2.T.DEPARTMENT_SELECTOR_CURRENT)})` : department.displayName;
            const departmentName = isDepartmentDisabled ? `${departmentNameCurrent} (${(0, index_2.Translate)(index_2.T.DEPARTMENT_SELECTOR_DISABLED)})` : departmentNameCurrent;
            const state = new radio_input_state_1.RadioInputState(departmentName, radioGroup);
            state.id = department.objectId;
            if (isCurrentDepartment) {
                state.setValue(true);
            }
            if (isDepartmentDisabled) {
                state.setDisabled(true);
            }
            states.push(state);
        }
        return states;
    }
    get nodes() {
        const children = [];
        for (const state of this.states) {
            children.push(radio_input_1.RadioInput.view(state));
        }
        return (0, mithril_1.m)('div', {
            className: department_selector_style_1.CSS.departmentOptions
        }, children);
    }
    submit() {
        let departmentId = null;
        for (const state of this.states) {
            if (state.value) {
                departmentId = state.id;
                break;
            }
        }
        if (departmentId == null) {
            throw new Error('No department selected');
        }
        return index_3.Services.UserSettings.setDepartment(departmentId).then(() => {
            // Redirect to home page if current page is not yet implemented in client-ui
            if (!index_3.Services.Route.supportDepartmentChange()) {
                index_3.Services.Route.go(page_1.IkePageName.map);
            }
        });
    }
    isDepartmentDisabled(department) {
        if (department.disableAt && Date.parse(department.disableAt) < Date.now()) {
            return true;
        }
        return false;
    }
}
exports.DepartmentSelectorModal = DepartmentSelectorModal;
tslib_1.__decorate([
    mobx_1.action
], DepartmentSelectorModal.prototype, "open", null);
//# sourceMappingURL=department.selector.js.map